import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="relative text-white bg-gray-900">
      {/* Background Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(/img/overlay2.png)',
          opacity: 0.1
        }}
      />

      <div className="container relative z-10 px-4 pt-20 pb-10 mx-auto">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <img src="/img/logo-bianco.png" alt="Cash For Cars Adelaide" className="h-12 mb-4" />
            <p className="mb-4 text-gray-400">
              We specialize in buying used vehicles throughout Adelaide 
              with immediate payment and maximum professionalism. Get the best value for your car today!
            </p>
            <div className="mt-6">
              <h5 className="mb-3 text-lg font-bold">Service Areas</h5>
              <p className="text-gray-400">
                Adelaide CBD, Eastern Suburbs, Western Suburbs, Northern Suburbs, Southern Suburbs, 
                Adelaide Hills, and surrounding areas
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="mb-4 text-lg font-bold">Quick Links</h5>
            <ul className="space-y-2">
              <li><a href="/" className="hover:text-blue-400">Home</a></li>
              <li><a href="/#how-it-works" className="hover:text-blue-400">How It Works</a></li>
              <li><a href="/#services" className="hover:text-blue-400">Services</a></li>
              <li><a href="/#brands" className="hover:text-blue-400">Brands</a></li>
              <li><a href="/#faq" className="hover:text-blue-400">FAQ</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h5 className="mb-4 text-lg font-bold">Contact Us</h5>
            <ul className="space-y-4">
              <li className="flex items-center">
                <MapPin className="w-5 h-5 mr-2" />
                Adelaide, South Australia
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 mr-2" />
                <a href="tel:+61451326175" className="hover:text-blue-400">+61 451 326 175</a>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 mr-2" />
                <a href="mailto:info@sellcareasy.com.au" className="hover:text-blue-400">
                  info@sellcareasy.com.au
                </a>
              </li>
            </ul>
            <div className="flex mt-6 space-x-4">
              <a href="#" className="hover:text-blue-400" aria-label="Follow us on Facebook">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="#" className="hover:text-blue-400" aria-label="Follow us on Instagram">
                <Instagram className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>

        {/* Newsletter */}
        {/* <div className="py-8 mt-12 border-t border-gray-800">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            <div>
              <h5 className="mb-2 text-lg font-bold">Stay Updated</h5>
              <p className="text-gray-400">Subscribe to our newsletter for the latest updates and offers</p>
            </div>
            <form className="flex">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-2 bg-gray-800 border-none rounded-l-md focus:ring-2 focus:ring-blue-500"
                aria-label="Email address"
              />
              <button 
                type="submit"
                className="px-6 py-2 text-white bg-blue-600 rounded-r-md hover:bg-blue-700 transition"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div> */}

        {/* Copyright */}
        <div className="pt-8 mt-8 text-center border-t border-gray-800">
          <p className="text-gray-400">
            © {new Date().getFullYear()} Sell Car Easy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};